<template slot-scope="scope">
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">销售计划查看&修改</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button @click="$router.go(-1)">返回</form-button>
        <form-button name="显示" @click="handleClick(true)" v-if="!isEdit"/>
        <form-button name="保存" @click="saveData('SAVE')" v-if="!isEdit && btnLimits.save"/>
        <form-button name="修改" @click="handleClick(false)" v-if="isEdit && btnLimits.edit"/>
        <form-button name="提交" @click="saveData('SUBMIT')" v-if="!isEdit && btnLimits.submit"/>
        <form-button name="审核通过" @click="saveData('APPROVE')" v-if="!isEdit && btnLimits.approve"/>
        <!-- <form-button name="提交OA" @click="showOaDialog=true" v-if="!isEdit && btnLimits.submit_oa"/> -->
        <form-button name="退回" @click="saveData('CANCEL')" v-if="!isEdit && btnLimits.cancel"/>
        <form-button name="作废" @click="saveData('VOID')" v-if="!isEdit && btnLimits.void"/>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        :show-message="false"
        label-width="100px"
        :model="conditions"
        :rules="isChangeList ? changeRules : rules"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input :value="conditions.plan_cntr_no" disabled />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-select :value="conditions.order_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0072']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划年度">
              <el-input :value="conditions.gjahr" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isChangeList">
          <!-- <el-col :lg="8" :md="12"> -->
            <!-- <el-form-item prop="chg_plan_cntr_no" class="line-16" label="销售计划申请编号"> -->
            <el-form-item prop="chg_plan_cntr_no" class="line-16" label="销售计划申请编号">
              <wly-input
                :disabled="isChangeListDetail"
                v-model="conditions.chg_plan_cntr_no"
                input-type="qySalePlan"
                @enter="handleInter"
                @handleSuffixClick="openSelectDialog($event, '销售计划选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="客户编号">
              <wly-input
                :disabled="isListDetail"
                @enter="handleEnter"
                @handleSuffixClick="openDialog($event, '客户选择')"
                v-model="conditions.customer"
                input-type="customer"
                :query-params="{mode: 'SPCT'}"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input :value="conditions.cust_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.customer_type" disabled clearable>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-select v-model="conditions.plan_type" clearable @change="changeVal($event,'plan_type')" :disabled="isListDetail">
                <el-option
                  v-for="item in planTypeList"
                  :key="item.newPlanType"
                  :label="item.newPlanTypeName"
                  :value="item.newPlanType"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-select v-model="conditions.chfl" clearable filterable @change="changeVal($event,'chfl')" :disabled="isListDetail">
                <el-option
                  v-for="item in chflList"
                  :key="item.chfl"
                  :label="item.chflName"
                  :value="item.chfl"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isChangeList">
            <el-form-item label="变更类型">
              <el-select :value="conditions.adj_reason" disabled clearable >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <!-- :disabled="isEdit" -->
              <el-select
                v-model="conditions.sal_center"
                placeholder=""
                @change="saleCenterChange"
                disabled
              >
                <el-option
                  v-for="item in saleCenterLists"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="大区副总审核" prop="zassign">
              <el-select
                v-model="conditions.zassign"
                @change="zassignChange($event)"
                placeholder=""
                :disabled="!isEdit ? !(btnLimits.edit && role.ROLE === 'WLY025') : true"
              >
                <el-option
                  v-for="item in zassignLists"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"

                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="conditions.zassign">
            <el-form-item label="大区副总" prop="assign">
              <el-select
                v-if="btnLimits.edit && role.ROLE === 'WLY025'"
                v-model="assignLists"
                @change="assignBpChange($event)"
                placeholder=""
                multiple
              >
                <el-option
                  v-for="item in deputyLists"
                  :key="item.partner"
                  :label="item.name"
                  :value="item.partner"
                />
              </el-select>
              <el-select
                v-else
                v-model="disCheckList"
                placeholder=""
                multiple
              >
                <el-option
                  disabled
                  v-for="item in assignLists"
                  :key="item.partner"
                  :label="item.name"
                  :value="item.partner"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约量">
              <el-input :value="conditions.pre_aloc_plan_qty" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约下限">
              <el-input :value="conditions.pre_aloc_min_qty" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约上限">
              <el-input :value="conditions.pre_aloc_max_qty" disabled />
            </el-form-item>
          </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="可组合签约产品年销售金额" class="lg-label">
                <el-input v-model="conditions.combination_amt" type="number" disabled/>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <span class="mark">(万/年) (有组合签约客户需填写) </span>
            </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="签约说明">
              <el-input
                :disabled="isQyDetail"
                v-model="conditions.signing_note"
                type="textarea"
                rows="4"
                maxlength="2000"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="!isChangeList">
            <el-form-item label="特殊说明">
              <el-input
                v-model="conditions.spec_note"
                rows="4"
                type="textarea"
                clearable
                :disabled="isEdit"
                maxlength="2000"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="!isEdit && (btnLimits.cancel || btnLimits.approve)">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_comment"
                rows="4"
                type="textarea"
                maxlength="2000"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input :value="conditions.uname_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建时间">
              <el-input :value="conditions.datum" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select :value="conditions.status" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0071']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <TableCommon v-if="!isChangeList" :title="countYearArea" :custome-config="() => vxeShowCustom('gridOptionArea')">

        <vxe-grid
          ref="gridOptionArea"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionArea.columns"
          :data="gridOptionArea.data"
        >
        </vxe-grid>
      </TableCommon>

      <TableCommon v-if="!isChangeList" :title="countYearChannel" :show-custome="false">
        <el-checkbox-group>
          <el-row>
            <el-col v-for="item in channelList" :key="item.channel" :lg="6" :md="8">
              <el-checkbox :label="item.channel" disabled>{{ item.chlName }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>
      <!-- <TableCommon v-if="!isChangeList" title="历史数据" :custome-config="() => vxeShowCustom('xTable2')">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsPlanDetail.columns"
          :data="gridOptionsPlanDetail.data"
          :span-method="mergeRowMethod"
        >
          <template v-for="item in gridOptionsPlanDetail.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon> -->
      <!-- 纯展示 -->
      <!-- <TableCommon v-if="isChangeList" :showCustome="showCustome" :title="countYearPlan" :custome-config="() => vxeShowCustom('orderDetail')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="300"
          align="center"
          size="medium"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridShowOptions.columns"
          :data="gridShowOptions.data"
        >
          <template v-for="item in gridShowOptions.columns" #[item.field]="{ row }">
            <div :key="item.field" >
              <el-input
                disabled
                v-if="
                  gridShowOptions.columnsFieldTypes[item.field] == 'input'
                "
                v-model="row[item.field]"
                size="mini"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon> -->
      <TableCommon :showCustome="showCustome" :title="isChangeList ? countYearPlan +'调整明细' : countYearPlan" :custome-config="() => vxeShowCustom('orderDetail')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="330"
          align="center"
          size="medium"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-style="rowStyle"
        >
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }" >
            <div :key="item.field" >
              <el-input
                :disabled="isEdit ? true : !row.dis"
                v-if="
                  gridOptions.columnsFieldTypes[item.field] == 'input'
                "
                v-model="row[item.field]"
                size="mini"
                oninput="value=value.replace(/[^\-?\d]/g, '')"
                @keyup.enter.native="saveSaleItem(item.field, row)"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <!-- <template #toolbar /> -->
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon
        title="外部系统关联数据"
        :custome-config="() => vxeShowCustom('yTable')"
      >
        <vxe-grid
          ref="yTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="550"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridSysOptions.columns"
          :data="gridSysOptions.data"
          >
            <template #file_name="{ row }" v-if="btnLimits.file">
              <span class="blue" @click="openUrl(row)">{{ row.file_name }}</span>
            </template>
          </vxe-grid>
          <template #main_contont="{row}" v-if="btnLimits.main_contont">
            <span>{{ row.main_contont }}</span>
          </template>
      </TableCommon>
      <TableCommon
        title="状态变更记录"
        :custome-config="() => vxeShowCustom('yTable')"
      >
        <vxe-grid
          ref="yTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="550"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridRecordOptions.columns"
          :data="gridRecordOptions.data"
        />
      </TableCommon>
    </div>
    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="销售计划选择"
      :visible.sync="showPlanDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showPlanDialog">
        <SalePlanNewList ref="dialogEdit" sourceType='detail' />
      </template>
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showPlanDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitPlanHandle">提交</el-button>
      </div>
    </el-dialog>
    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <ClientSelect ref="dialogSelect" mode="SPCT"/>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
    <!-- 提交OA -->
    <el-dialog
      v-dialogDrag
      title="提交OA审批"
      :visible.sync="showOaDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showOaDialog">
        <div>
          <el-form ref="oaForm" :rules="oaRules" :model="dialogForm" label-width="90px">
            <el-form-item label="正文">
              <el-input type="textarea" rows="3" resize="none" v-model="dialogForm.main_contont" disabled></el-input>
            </el-form-item>
            <el-form-item label="大区意见">
              <el-input type="textarea" rows="3" resize="none" v-model="dialogForm.audit_comment"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showOaDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="getSendOAFiles">确认</el-button>
      </div>
    </el-dialog>
    <!-- 作废 -->
    <el-dialog
      v-dialogDrag
      title="作废"
      :visible.sync="showRepealDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showRepealDialog">
        <div>
          <el-form ref="oaForm" :rules="oaRules" :model="dialogForm" label-width="90px">
            <el-form-item label="作废原因">
              <el-input type="textarea" rows="3" resize="none" v-model="dialogForm.audit_comment"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showRepealDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="getSendOAFiles">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findchflList, findnewPlanTypeList, findSaleplanHistory, findContractArea, findContractChannel, findBrandPrice, getSendOAFiles} from '@/api/signing'
import {spctNewOrder, getSpctById, spctChgOrder, getCenterFz} from '@/api/sap/signing-sap'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
const SalePlan = () => import('@/components/dialog/SalePlan.vue')
import SalePlanNewList from './salePlanNewList.vue'
import { Message } from 'element-ui'
import { formatWlyYear } from '@/utils/handleFormData'
export default {
  components: {
    ClientSelect,
    SalePlanNewList
  },
  data() {
      return {
        disCheckList: [],
        assignLists: [],
        checkAssign: [],
        btnLimits: {
          edit: '',
          save: '',
          submit: '',
          approve: '',
          cancel: '',
          submit_oa: '',
          void: '',
        },
        deputyLists: [],
        deputy: '',
        clientDialog: false,
        zassignLists: [
          {
            key: 'X',
            value: '是'
          },
          {
            key: '',
            value: '否'
          }
        ],
        showRepealDialog: false,
        bgjhl: [],
        copyChflList: [],
        showCustome: false,
        dialogForm: {
          main_contont: '',
          audit_comment: '',
        },
        totalRecomQy: 0,
        totalRecomPrice: 0,
        totalRealityQy: 0,
        totalRealityPrice: 0,
        showOaDialog: false,
        saveGridOptions: [],
        showPlanDialog: false,
        isEdit: true,
        mode: '',
        saleCenterLists: [],
        chflList: [],
        planTypeList: [],
        countYear: '',
        countYearArea: '',
        countYearChannel: '',
        countYearPlan: '',
        showDialog: false,
        selectDataOptions: {},
        oaRules: {
          audit_comment: [{ required: true, message: '请填写大区意见', trigger: 'change' }],
        },
        rules: {
          customer: [{ required: true, message: '请选择客户', trigger: 'change' }],
          plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
          chfl: [{ required: true, message: '请选择存货分类', trigger: 'change' }],
          signing_note: [{ required: true, message: '请填写签约说明', trigger: 'change' }],
        },
        changeRules: {
          chg_plan_cntr_no: [{ required: true, message: '请填写销售计划申请编号', trigger: 'change' }],
          signing_note: [{ required: true, message: '请填写签约说明', trigger: 'change' }],
        },
        loading: false,
        errorList: [],
        orderTypeList:[
          {
            value:'ZP01',
            name: '新增单'
          },
          {
            value:'ZP02',
            name: '销售计划量签约变更单'
          },
        ],
        conditions: {
          customer: '',
          cust_name: '',
          customer_type: '',
          sal_center: '',
          saleCenterTextView: '',
          brandTextView: '',
          planTypeTextView: '',
          gjahr: 2024,
          order_type_text: '新增单',
          order_type: 'ZP01',
          cntrname: '',
          status: 'E001', // 状态
          ZZFLD000001Name: '',
          ZZFLD00003E: '',
          posting_date: '',
          uname_text: '',
          adj_reason:'V013',
          zassign: '',
          assign: [],
          pre_aloc_plan_qty: ''
        },
        gridOptionsPlanDetail: {
          columns: [
            { type: 'seq', field: 'seq', title: '序号', width: 50 },
            {
              field: 'planQty21',
              title: '2021年计划量',
            },
            {
              field: 'billQty21',
              title: '2021年开票数量',
            },
            {
              field: 'planQty22',
              title: '2022年计划量',
            },
            {
              field: 'billQty22',
              title: '2022年开票数量',
            },
            {
              field: 'planQty23',
              title: '2023年计划量',
            },
            {
              field: 'billQty23',
              title: '2023年开票数量',
            },
            {
              field: 'deliverQty21',
              title: '2021年发货数量',
            },
            {
              field: 'deliverQty22',
              title: '2022年发货数量',
            },
            {
              field: 'deliverQty23',
              title: '2023年发货数量',
            },
            {
              field: 'breakRuleQty',
              title: '2023年违规数量',
            },
            {
              field: 'omitQty',
              title: '遗留扣减量',
            },
            {
              field: 'selledStock',
              title: '库存',
            },
            {
              field: 'selledQty21',
              title: '2021年动销量',
            },
            {
              field: 'selledQty22',
              title: '2022年动销量',
            },
            {
              field: 'selledQty23',
              title: '2023年动销量',
            },
            // {
            //   field: 'signedQty',
            //   title: '参考量',
            // },
          ],
          data: []
        },
        gridOptionsFile: {
          columns: [
            { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
            {
              field: 'filename',
              title: '附件名称',
              slots: { default: 'filename' }
            },
            { field: 'mimetype', title: '附件类型' },
            {
              field: 'filelength',
              title: '大小',
              formatter: ({ cellValue }) => formatSapFileSize(cellValue)
            },
            {
              field: 'created_date',
              title: '上传日期',
              formatter: ({ cellValue }) => formatSapDate(cellValue)
            },
            {
              field: 'created_time',
              title: '上传时间',
              formatter: ({ cellValue }) => formatSapTime(cellValue)
            }
          ],
          data: [],
          delData: []
        },
        gridOptionArea: {
          columns: [
            { type: 'seq', field: 'seq', title: '序号', width: 50 },
            { field: 'regn_name', title: '经营区域/省份/直销市',},
            { field: 'city_name', title: '经营区域/城市/地区',},
            { field: 'street_name', title: '经营区域/区县',}
          ],
          data: []
        },
        gridOptions: {
          columns: [
            {
              field: 'oper_name',
              title: '分配人',
              width: 120,
            },
            {
              field: 'plan_qty_12',
              title: '12月份',
              slots: { default: 'plan_qty_12' }
            },
            {
              field: 'plan_qty_1',
              title: '1月份',
              slots: { default: 'plan_qty_1' }
            },
            {
              field: 'plan_qty_2',
              title: '2月份',
              slots: { default: 'plan_qty_2' }
            },
            {
              field: 'plan_qty_3',
              title: '3月份',
              slots: { default: 'plan_qty_3' }
            },
            {
              field: 'plan_qty_4',
              title: '4月份',
              slots: { default: 'plan_qty_4' }
            },
            {
              field: 'plan_qty_5',
              title: '5月份',
              slots: { default: 'plan_qty_5' }
            },
            {
              field: 'plan_qty_6',
              title: '6月份',
              slots: { default: 'plan_qty_6' }
            },
            {
              field: 'plan_qty_7',
              title: '7月份',
              slots: { default: 'plan_qty_7' }
            },
            {
              field: 'plan_qty_8',
              title: '8月份',
              slots: { default: 'plan_qty_8' }
            },
            {
              field: 'plan_qty_9',
              title: '9月份',
              slots: { default: 'plan_qty_9' }
            },
            {
              field: 'plan_qty_10',
              title: '10月份',
              slots: { default: 'plan_qty_10' }
            },
            {
              field: 'plan_qty_11',
              title: '11月份',
              slots: { default: 'plan_qty_11' }
            },
            {
              field: 'aloc_total_qty',
              title: '月度计划量合计',
              slots: { default: 'aloc_total_qty' }
            },
            {
              field: 'price',
              title: '单价',
              width: 60,
              slots: { }
            },
            {
              field: 'total_price',
              title: '总金额(万元)',
              width: 80,
            },
          ],
          data: [
            {
              total: '',
              plan_qty_1: '',
              plan_qty_2: '',
              plan_qty_3: '',
              plan_qty_4: '',
              plan_qty_5: '',
              plan_qty_6: '',
              plan_qty_7: '',
              plan_qty_8: '',
              plan_qty_9: '',
              plan_qty_10: '',
              plan_qty_11: '',
              plan_qty_12: '',
              price:'9999',
              total_price: ''
            }
          ],
          columnsFieldTypes: {
            total: 'input',
            aloc_total_qty: 'input',
            plan_qty_1: 'input',
            plan_qty_2: 'input',
            plan_qty_3: 'input',
            plan_qty_4: 'input',
            plan_qty_5: 'input',
            plan_qty_6: 'input',
            plan_qty_7: 'input',
            plan_qty_8: 'input',
            plan_qty_9: 'input',
            plan_qty_10: 'input',
            plan_qty_11: 'input',
            plan_qty_12: 'input',
          }
        },
        gridRecordOptions: {
          data: [],
          columns: [
            { field: 'operationer', title: '操作员' },
            { field: 'oper_name', title: '操作员姓名' },
            { field: 'status_text', title: '操作状态' },
            { field: 'audit_comment', title: '审核意见'},
            { field: 'changin_date', title: '变更日期',formatter: ({ cellValue }) => formatSapDate(cellValue) },
            { field: 'changin_time', title: '变更时间',formatter: ({ cellValue }) => formatSapTime(cellValue)  }
          ]
        },
        gridSysOptions:{
          data: [],
          columns: [
            { field: 'approval_no', title: 'OA审批单号' },
            { field: 'operationer', title: '操作员' },
            { field: 'oper_name', title: '操作员姓名' },
            { field: 'main_contont', title: '正文' },
            { field: 'audit_comment', title: '大区意见'},
            { field: 'file_name', title: '附件地址', slots: { default: 'file_name' }},
            { field: 'created_date', title: '创建日期',formatter: ({ cellValue }) => formatSapDate(cellValue) },
            { field: 'created_time', title: '创建时间',formatter: ({ cellValue }) => formatSapTime(cellValue)  }
          ]
        },
        validRules: {},
        chanelCheckList: [],
        channelList: [],
      }
  },
  computed: {
    // 进入页面显示哪些按钮
    isEnter(){
      const arr1 = ['WLYALL','WLY014']
      const arr2 = ['E001','E002']
      if(arr1.indexOf(this.role.ROLE) > -1 && arr2.indexOf(this.conditions.status) > -1){
        return true
      }
      if(this.conditions.status === 'E003'){
        if(this.role.ROLE === 'WLY013' && this.conditions.sal_center !== this.role.deptCode || this.role.ROLE === 'WLYALL'){
          return true
        }
      }
      const arr3 = [ 'WLY025','WLYALL']
      if(arr3.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E004'){
        return true
      }
      const arr4 = ['E013','E008','E005']
      if(arr4.indexOf(this.conditions.status) > -1 && ((this.role.ROLE === 'WLY013' && this.conditions.sal_center === this.role.deptCode) || this.role.ROLE === 'WLYALL')){
        return true
      }
      if(this.conditions.status === 'E012'){
        if(this.conditions.zassign === '' && !this.deputy){
          return true
        }
        if(this.conditions.zassign === 'X' && this.deputy){
          return true
        }
        if(this.role.ROLE === 'WLYALL'){
          return true
        }
      }
      const arr5 = ['WLY002','WLYALL']
      if(this.conditions.status === 'E007' && arr5.indexOf(this.role.ROLE) > -1){
        return true
      }
      return false
    },
    // 显示‘提交’和‘退回’按钮；
    isSubmit(){
      const arr = ['WLY013','WLY014','WLYALL']
      if(arr.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E002'){
          return true
        }
        return false
    },
    // 审批通过+退回
    isApprove(){
      const arr1 = ['WLY013','WLYALL']
      const arr2 = ['E003', 'E008', 'E013','E012']
      if(arr1.indexOf(this.role.ROLE) > -1 && arr2.indexOf(this.conditions.status) > -1){
        return true
      }
      const arr3 = ['WLYALL','WLY025']
      if(arr3.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E004'){
        return true
      }
      // if(this.conditions.status === 'E012'){
      //   if(this.role.ROLE === 'WLYALL'){
      //     return true
      //   }
      //   if( this.role.ROLE === 'WLY013' && (this.conditions.zassign === 'X' && this.conditions.assign_bp === this.role.USER_BP || this.conditions.zassign === '')){
      //     return true
      //   }
      // }
      return false
    },
    // 单独退回
    isBack(){
      if(this.conditions.status === 'E003' && this.role.ROLE === 'WLY014'){
        return true
      }
      if(this.conditions.status === 'E005' && this.role.ROLE === 'WLY013' && this.conditions.sal_center === this.role.deptCode || this.role.ROLE === 'WLYALL'){
        return true
      }
      return false
    },
    // 提交OA
    isOa(){
      const arr1 = ['WLY013','WLYALL']
      if(arr1.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E005'){
        return true
      }
      return false
    },
    // 审核通过
    isPass(){
      const arr2 = ['WLY002','WLYALL']
      if(arr2.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E007'){
        return true
      }
      return false
    },
    // 显示按钮
    isShow(){
      const arr = ['WLY013','WLY014','WLY025 ','WLYALL']
        if(arr.indexOf(this.role.ROLE) > -1 ){
          return true
        }
        return false
    },
    // 是否是变更单
    isChangeList(){
      return this.conditions.order_type === 'ZP02'
    },
    // 草稿
    isDraft(){
      const arr = ['WLY013','WLY014','WLYALL']
      if(arr.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E002'){
        return true
      }
      return false
    },
    // 填写签约
    isQyDetail(){
      if(!this.isEdit){
        if(this.conditions.status === 'E001' || this.conditions.status === 'E002'){
          return false
        }
        // if(this.conditions.status === 'E002'){
        //   if(this.isChangeList){
        //     return !this.isDraft
        //   }else{
        //     return !this.isDraft
        //   }
        // }
        // return !this.isApprove
      }
      return true
    },
    // 新增单修改
    isListDetail(){
      if(!this.isEdit && this.isDraft && !this.isChangeList){
       return false
      }
      return true
    },
    // 变更单修改
    isChangeListDetail(){
      if(!this.isEdit && this.isDraft && this.isChangeList){
       return false
      }
      return true
    },
    //计划明细
    isPlanList(){
      const arr = ['WLY013','WLY014','WLYALL']
      const newStatus = arr.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E001'
      if(!this.isEdit && !newStatus && this.isChangeList){
       return false
      }
      if(!this.isEdit && !newStatus && !this.isChangeList){
       return false
      }
      return true
    },
    isRepeal(){
      const arr = ['WLY002','WLYALL']
      if(this.conditions.status === 'E009' && arr.indexOf(this.role.ROLE) > -1){
        return this.conditions.order_type === 'ZP01'
      }
      return false
    },
    ...mapGetters(['customerInfo', 'role'])
  },

  watch:{

  },
  created() {
    this.conditions.gjahr = formatWlyYear()
    const {plan_cntr_no} = this.$route.query
    if(plan_cntr_no){
      this.getSpctById(plan_cntr_no)
    }
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0071')
    this.getSelectDictDataOrigin('A0072')
    this.getSelectDictDataOrigin('A0043')
    this.getSelectDictDataOrigin('orgList')
    // this.getContractQd()
    this.conditions.uname_text = this.role.login_user
    this.conditions.posting_date = this.$utilsCommon.parseTime(
      new Date().getTime(),
      '{y}-{m}-{d}'
    )
    this.countYearArea = this.conditions.gjahr + '年营销区域'
    this.countYearChannel = this.conditions.gjahr +'年营销渠道'
    this.countYearPlan = this.conditions.gjahr +'年计划量'
  },
  methods: {
    getBolb(url){
      return new Promise(resolve=>{
        const xhr = new XMLHttpRequest()
        xhr.open('GET',url,true)
        xhr.responseType = 'blob'
        xhr.onload =()=>{
          if(xhr.status === 200){
            resolve(xhr.response)
          }
        }
        xhr.send()
      })
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        const body = document.querySelector('body')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename

        // fix Firefox
        link.style.display = 'none'
        body.appendChild(link)

        link.click()
        body.removeChild(link)

        window.URL.revokeObjectURL(link.href)
      }
    },
    // 下载外部系统关联数据文件
    openUrl(row) {
      const fileName = row.file_name
      const url = row.file_addr
      // window.open(row.file_addr)
      this.getBolb(url).then((blob)=>{
        this.saveAs(blob,fileName)
      })
      // const fileName = row.file_name
      // const url = row.file_addr
      // const x = new XMLHttpRequest()
      // x.open('GET', url, true)
      // x.responseType = 'blob'
      // x.onload = function() {
      //   const url = window.URL.createObjectURL(x.response)
      //   const a = document.createElement('a')
      //   a.href = url
      //   a.download = fileName
      //   a.click()
      // }
      // x.send()
    },
    rowStyle({ row, rowIndex }) {
      if (!row.dis) {
        return {
          backgroundColor: '#f2f8fe',
        }
      }
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
      // fields是哪些需要合并的单元格
      const fields1= [
        'breakRuleQty',
        'omitQty',
        'selledStock',
        'selledQty21',
        'selledQty22',
        'selledQty23',
      ]
      if (row[column.property] && fields1.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // 当满足以下条件才去合并上面的单元格
        if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['brandTextView'] === row['brandTextView'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['brandTextView'] === row['brandTextView'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }else if (row[column.property] && column.property === 'signedQty') {
        // const prevRow = visibleData[_rowIndex - 1]
        // let nextRow = visibleData[_rowIndex + 1]
        // // 当满足以下条件才去合并上面的单元格
        // if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && prevRow['brandTextView'] === row['brandTextView']) {
        //   return { rowspan: 0, colspan: 0 }
        // } else {
        //   let countRowspan = 1
        //   while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && nextRow['brandTextView'] === row['brandTextView']) {
        //     nextRow = visibleData[++countRowspan + _rowIndex]
        //   }
        //   if (countRowspan > 1) {
        //     return { rowspan: countRowspan, colspan: 1 }
        //   }
        // }
      }
    },
    handleClick(flag){
      this.isEdit = flag
      const flagType = this.gridOptions.columns.some((item)=>{ return item.field === 'qty_type_text'})
      const idx = flagType ? 2 : 1
      // 处理新增一行明细
      if(this.gridOptions.data.length === this.saveGridOptions.length && this.isApprove){
        let res = {
          plan_qty_1: '',
          plan_qty_2: '',
          plan_qty_3: '',
          plan_qty_4: '',
          plan_qty_5: '',
          plan_qty_6: '',
          plan_qty_7: '',
          plan_qty_8: '',
          plan_qty_9: '',
          plan_qty_10: '',
          plan_qty_11: '',
          plan_qty_12: '',
          price:'',
          total_price: '',
          dis: '1',
          qty_type_text: '本次调整量',
          qty_type: ''
        }
        const arr = [1,2,3,4,5,6,7,8,9,10,11,12]
        this.gridOptions.data.forEach(ele => {
          ele.total = ele.aloc_total_qty
          arr.forEach(item => {
            res['plan_qty_'+item] = ele['plan_qty_'+item]
            res.total_price = ele.total_price
            res.aloc_total_qty = ele.aloc_total_qty
            res.total = ele.aloc_total_qty
          });
        });
        // if(this.role.ROLE === 'WLY014'){
        //   res.qty_type = 'V005'
        //   res.qty_type_text = '渠道经理调整量'
        // }else if(this.role.ROLE === 'WLY013'){
        //   if(this.conditions.sal_center === this.role.deptCode){
        //     res.qty_type = 'V007'
        //     res.qty_type_text = '大区总经理调整量'
        //   }else{
        //     res.qty_type = 'V006'
        //     res.qty_type_text = '区域总经理调整量'
        //   }
        // }else if(this.role.ROLE === 'WLYALL'){
        //   if(this.conditions.status === 'E001' || this.conditions.status === 'E002'){
        //     res.qty_type = 'V005'
        //     res.qty_type_text = '渠道经理调整量'
        //   }else if(this.conditions.status === 'E003'){
        //     res.qty_type = 'V006'
        //     res.qty_type_text = '区域总经理调整量'
        //   }else if(this.conditions.status === 'E004' || this.conditions.status === 'E008'){
        //     res.qty_type = 'V007'
        //     res.qty_type_text = '大区总经理调整量'
        //   }
        // }
        this.gridOptions.data.push(res)
        if(!flag){
          this.gridOptions.columns.splice(idx, 0, {
            field: 'total',
            title: '申请计划量',
            width: 70,
            slots: { default: 'total' }
          })
        }
        this.findBrandPrice()
      }
      if(flag && this.gridOptions.data.length !== this.saveGridOptions.length){
        this.gridOptions.data.pop()
        this.gridOptions.columns.splice(idx,1)
      }
    },
    // 打开窗口
    openSelectDialog(e) {
      e.target.blur()
      this.showPlanDialog = true
    },
    // 销售计划弹窗内的方法这边来处理，方便数据回调在本页面处理
    async submitPlanHandle() {
      this.disCheckList = []
      const data = await this.$refs.dialogEdit.submitCheckedForm()
      if (data.plan_cntr_no) {
        const params = {
          dept_code: this.role.deptCode,
          user_bp: this.role.USER_BP,
          plan_cntr_no: data.plan_cntr_no,
        }
        const { order_type, status } = this.$route.query
        const arr = ['E001','E002','E003', 'E004']
        if(order_type === 'ZP02' && arr.indexOf(status) > -1){
          params.mode = 'PD'
        }else{
          delete  params.mode
        }
        const res = await getSpctById(params)
        if(res.msgtype === "E"){
          return Message.warning(res.message)
        }
        this.conditions.assign = res.data.assign
        this.assignLists = res.data.assign
        res.data.assign.forEach(ele => {
          this.disCheckList.push(ele.partner)
        });
        this.btnLimits = res.data.button
        this.gridOptionsFile.data = [...res.data.attachment]
        this.conditions.customer = res.data.head.customer
        this.findnewPlanTypeList()
        this.findchflList()
        this.conditions.cust_name = res.data.head.cust_name
        this.conditions.customer_type = res.data?.head?.customer_type
        this.conditions.chg_plan_cntr_no =  res.data?.head?.plan_cntr_no
        this.conditions.chfl = res.data?.head?.chfl
        this.conditions.datum = res.data?.head?.datum
        this.conditions.uname_text = res.data?.head?.uname_text
        this.conditions.plan_type = res.data?.head?.plan_type
        this.conditions.sal_center = res.data?.head?.sal_center

        this.bgjhl = Object.assign([], res.data.bgjhl)
        this.gridOptions.data = res.data.bgjhl
        const flag = this.gridOptions.columns.some((item)=>{ return item.field !== 'qty_type_text'})
        if(flag){
          this.gridOptions.columns.splice(1, 0, {
            field: 'qty_type_text',
            title: '类型',
            width: 90,
          })
        }
        this.gridOptions.data.push({
          ...res.data.item[0],
          dis: '1'
        })
        this.gridOptions.data.forEach((ele,index) => {
          for (const key in ele) {
            if (Object.hasOwnProperty.call(ele, key)) {
              const element = ele[key];
              console.log(`output->`,ele,key,ele[key])
              if(ele[key].indexOf('-')>-1){
                this.gridOptions.data[index][key] = '-' + ele[key].replace('-', '')
              }
            }
          }
        });

        res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
          this.gridOptionsPlanDetail.data.push({
            planQty21: ele.plan_qty_21,
            planQty22: ele.plan_qty_22,
            planQty23: ele.plan_qty_23,
            billQty21: ele.bill_qty_21,
            billQty22: ele.bill_qty_22,
            billQty23: ele.bill_qty_23,
            deliverQty21: ele.deliver_qty_21,
            deliverQty22: ele.deliver_qty_22,
            deliverQty23: ele.deliver_qty_23,
            selledStock: ele.selled_stock,
            selledQty21: ele.selled_qty_21,
            selledQty22: ele.selled_qty_22,
            selledQty23: ele.selled_qty_23,
            omitQty: this.conditions.legacy_deduction,
            breakRuleQty: this.conditions.viola_qty,
          })
        });
        this.gridRecordOptions.data = res.data?.history || []
      }
      this.showPlanDialog = false
    },
    // 申请编号 控件回车
    async handleInter(e, type, res) {
    console.log('handleInter', type, res)
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!res) return
      this.gridOptionsFile.data = [...res.data.attachment]
      this.conditions.customer = res.data.head.customer
      this.findchflList()
      this.findnewPlanTypeList()
      this.conditions.cust_name = res.data.head.cust_name
      this.conditions.customer_type = res.data?.head?.customer_type
      this.conditions.chfl = res.data?.head?.chfl
      this.conditions.datum = res.data?.head?.datum
      this.conditions.uname_text = res.data?.head?.uname_text
      this.conditions.plan_type = res.data?.head?.plan_type
      this.conditions.sal_center = res.data?.head?.sal_center
      this.gridRecordOptions.data = res.data?.history || []
      this.bgjhl = Object.assign([], res.data.bgjhl)
      this.gridOptions.data = res.data.bgjhl
      const flag = this.gridOptions.columns.some((item)=>{ return item.field === 'qty_type_text'})
      if(flag){
        this.gridOptions.columns.splice(1, 0, {
          field: 'qty_type_text',
          title: '类型',
          width: 90,
        })
      }
      this.gridOptions.data.push({
        ...res.data.item[0],
        dis: '1'
      })
      this.gridOptions.data.forEach((ele,index) => {
        for (const key in ele) {
          if (Object.hasOwnProperty.call(ele, key)) {
            const element = ele[key];
            console.log(`output->`,ele,key,ele[key])
            if(ele[key].indexOf('-')>-1){
              this.gridOptions.data[index][key] = '-' + ele[key].replace('-', '')
            }
          }
        }
      });
      res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
        this.gridOptionsPlanDetail.data.push({
          planQty21: ele.plan_qty_21,
          planQty22: ele.plan_qty_22,
          planQty23: ele.plan_qty_23,
          billQty21: ele.bill_qty_21,
          billQty22: ele.bill_qty_22,
          billQty23: ele.bill_qty_23,
          deliverQty21: ele.deliver_qty_21,
          deliverQty22: ele.deliver_qty_22,
          deliverQty23: ele.deliver_qty_23,
          selledStock: ele.selled_stock,
          selledQty21: ele.selled_qty_21,
          selledQty22: ele.selled_qty_22,
          selledQty23: ele.selled_qty_23,
          omitQty: this.conditions.legacy_deduction,
          breakRuleQty: this.conditions.viola_qty,
        })
      });
    },
    // 查单价
    async findBrandPrice(type){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        planType: this.conditions.plan_type,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr
      }
      const { data } = await findBrandPrice(params)
      this.gridOptions.data[this.gridOptions.data.length - 1].price = data || 0
      if(type === 'chfl' && this.gridOptions.data[0].aloc_total_qty){
        const bottle = this.conditions.chfl ===  '011102'? 2 : 6
        let total = this.gridOptions.data[0].aloc_total_qty * bottle * this.gridOptions.data[0].price/10000
        total = Math.round((total + Number.EPSILON)*10000) / 10000
        this.gridOptions.data[0].total_price = total.toFixed(4)
      }
    },
    saveSaleItem(title ,row){
      console.log(title, row,'090')
      const bottle = this.conditions.chfl ===  '011102'? 2 : 6
      const arr = [1,2,3,4,5,6,7,8,9,10,11,12]
      this.gridOptions.data = JSON.parse(JSON.stringify(this.gridOptions.data))
      // this.gridOptions.data[this.gridOptions.data.length - 1] = {...row,aloc_total_qty:''}
      // 平分数量
      if(title === 'aloc_total_qty'){
        this.gridOptions.data.forEach((ele,index) => {
          if((this.gridOptions.data[index].aloc_total_qty - 0) &&  Math.floor((this.gridOptions.data[index].aloc_total_qty - 0)/12) === ((this.gridOptions.data[index].aloc_total_qty - 0)/12)){
            arr.forEach(item => {
              this.gridOptions.data[index]['plan_qty_'+item] = ((this.gridOptions.data[index].aloc_total_qty - 0)/12)
            });
            let num = (this.gridOptions.data[index].aloc_total_qty - 0) * bottle  * this.gridOptions.data[index].price  /10000
            num =  Math.round((num + Number.EPSILON)*10000) / 10000
            this.gridOptions.data[index].total_price = num.toFixed(4)
          }
        });
      }else{
        this.gridOptions.data.forEach((item, index) => {
          this.gridOptions.data[index].aloc_total_qty = 0
        })
        // 计算总价
        this.gridOptions.data.forEach((item, index) => {
          arr.forEach(ele => {
            if( this.gridOptions.data[index]['plan_qty_'+ele]){
              this.gridOptions.data[index].aloc_total_qty = ( this.gridOptions.data[index].aloc_total_qty - 0) + ( this.gridOptions.data[index]['plan_qty_'+ele] - 0)
              let num =  this.gridOptions.data[index].aloc_total_qty * bottle *  this.gridOptions.data[index].price /10000
              num =  Math.round((num + Number.EPSILON)*10000) / 10000
              this.gridOptions.data[index].total_price = num.toFixed(4)
            }
          });
        });
      }
    },
    // 根据签约号查询详情
    async getSpctById(plan_cntr_no){
      this.disCheckList = []
      const params = {
        dept_code: this.role.deptCode,
        user_bp: this.role.USER_BP,
        plan_cntr_no,
      }
      const { order_type, status } = this.$route.query
      const arr = ['E001','E002','E003', 'E004']
      if(order_type === 'ZP02' && arr.indexOf(status) > -1){
        params.mode = 'PD'
      }else{
        delete  params.mode
      }
      this.gridOptions.columns.forEach((ele,idx) => {
        if(ele.field && ele.field === 'total'){
          this.gridOptions.columns.splice(idx,1)
        }
      });
      const res = await getSpctById(params)
      if(res.msgtype === "E"){
        return Message.warning(res.message)
      }
      this.conditions.assign = res.data.assign
      this.assignLists = res.data.assign
      res.data.assign.forEach(ele => {
        this.disCheckList.push(ele.partner)
      });
      this.btnLimits = res.data.button
      if(!res.data.button.file){
        this.gridSysOptions.columns.forEach((ele,idx) => {
          if(ele.field === 'file_name'){
            this.gridSysOptions.columns.splice(idx,1)
          }
        });
      }
      if(!res.data.button.main_contont){
        this.gridSysOptions.columns.forEach((ele,idx) => {
          if(ele.field === 'main_contont'){
            this.gridSysOptions.columns.splice(idx,1)
          }
        });
      }

      this.getCenterFz(res.data.head)
      this.gridOptionArea.data = [...res.data.area]
      this.conditions = {...res.data.head}
      this.findchflList()
      this.findnewPlanTypeList()
      this.countYearArea = this.conditions.gjahr + '年营销区域'
      this.countYearChannel = this.conditions.gjahr +'年营销渠道'
      this.countYearPlan = this.conditions.gjahr +'年计划量'
      if(this.conditions.order_type === 'ZP02'){
        this.bgjhl = Object.assign([], res.data.bgjhl)
        const item = Object.assign([], res.data.item)
        item.forEach(ele => {
          ele.dis = this.conditions.status === 'E002' ? '1' : ''
        });
        this.gridOptions.data = [...this.bgjhl, ...res.data.item ]
        const flag = this.gridOptions.columns.some((item)=>{ return item.field !== 'qty_type_text'})
        if(flag){
          this.gridOptions.columns.splice(1, 0, {
            field: 'qty_type_text',
            title: '类型',
            width: 90,
          })
        }
      }else{
        this.gridOptions.data = [ ...res.data.item ]
        this.gridOptions.data.forEach(ele => {
          ele.dis = this.conditions.status === 'E002' ? '1' : ''
        });
      }
      this.gridOptions.data.forEach((ele,index) => {
        for (const key in ele) {
          if (Object.hasOwnProperty.call(ele, key)) {
            const element = ele[key];
            // console.log(`output->`,ele,key,ele[key])
            if(ele[key].indexOf('-')>-1){
              this.gridOptions.data[index][key] = '-' + ele[key].replace('-', '')
            }
          }
        }
      });
      this.gridOptionsFile.data = [...res.data.attachment]
      this.saveGridOptions = [...this.bgjhl, ...res.data.item ]
      this.gridRecordOptions.data = res.data?.history || []
      this.gridSysOptions.data = res.data?.ext_sys || []
      this.saleCenterLists = [{
        zzfld00001h: res.data?.head?.sal_center,
        mc_short: res.data?.head?.sal_center_text,
      }]
      this.gridOptionsPlanDetail.data = []
      res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
        this.gridOptionsPlanDetail.data.push({
          planQty21: ele.plan_qty_21,
          planQty22: ele.plan_qty_22,
          planQty23: ele.plan_qty_23,
          billQty21: ele.bill_qty_21,
          billQty22: ele.bill_qty_22,
          billQty23: ele.bill_qty_23,
          deliverQty21: ele.deliver_qty_21,
          deliverQty22: ele.deliver_qty_22,
          deliverQty23: ele.deliver_qty_23,
          selledStock: ele.selled_stock,
          selledQty21: ele.selled_qty_21,
          selledQty22: ele.selled_qty_22,
          selledQty23: ele.selled_qty_23,
          omitQty: this.conditions.legacy_deduction,
          breakRuleQty: this.conditions.viola_qty,
          // histPlanQty: ele.his_plan_qty,
          // billQty: ele.invoice_qty,
          // deliverQty: ele.shipped_qty,
          // leftQty: ele.shipped_rem_qty,
          // selledStock: ele.moving_inventory,
          // selledQty: ele.moving_qty,
        })
      });
      this.findContractChannel()
      this.dialogForm.main_contont = '本次提报1家订单客户的配额计划，参考总量' + this.conditions.pre_aloc_plan_qty + '件，总金额'+this.conditions.pre_aloc_plan_amt+'(万元)，营销大区实际确定签约量共' + this.saveGridOptions[0].aloc_total_qty + '件，总金额' + this.saveGridOptions[0].total_price + '(万元)。'
    },
    async getCenterFz(data, type = ''){
      const params = {
        user_bp: this.role.USER_BP,
        sal_center: [
        {
          high: "",
          low: data.sal_center,
          option: "EQ",
          sign: "I",
        }
        ],
      }
      // if(type){
      //   params.partner = [{
      //     high: "",
      //     low: this.role.USER_BP,
      //     option: "EQ",
      //     sign: "I",
      //   }]
      // }
      const res = await getCenterFz(params)
      this.deputy = res.data.length > 0
      this.deputyLists = res.data
    },
    changeVal(e,type){
      if(this.conditions.customer && this.conditions.sal_center && this.conditions.chfl && this.conditions.plan_type){
        this.findSaleplanHistory()
        this.findContractArea()
        this.findContractChannel()
        this.findBrandPrice(type)
      }
      if(type === 'plan_type'){
        const isQarr = []
        const noQarr = []
        this.copyChflList.forEach(ele => {
          if(ele.chfl === '0122' || ele.chfl === '0133' || ele.chfl === '011102'){
            isQarr.push(ele)
          }
          if(ele.chfl === '0122' || ele.chfl === '0102' || ele.chfl === '010802' || ele.chfl === '0176'){
            noQarr.push(ele)
          }
        });
        this.chflList = e === 'V107' ? isQarr : noQarr
        if(e === 'V107' && (this.conditions.chfl !== '0122' || this.conditions.chfl !=='0133' || this.conditions.chfl !== '011102')){
          this.conditions.chfl = ''
        }
        if(e !== 'V107' && (this.conditions.chfl ==='0133' || this.conditions.chfl === '011102')){
          this.conditions.chfl = ''
        }
      }else{
        if(this.conditions.plan_type === 'V107' && (e !== '0122' && e !=='0133' && e !=='011102')){
          this.conditions.plan_type = ''
        }
        if(this.conditions.plan_type !== 'V107' && ( e ==='0133' || e ==='011102')){
          this.conditions.plan_type = ''
        }
      }
    },
    // 存货分类接口
    async findchflList(){
      const res = await findchflList({customerCode: this.conditions.customer})
      this.chflList = res.data || []
      this.copyChflList = res.data || []
    },
    // 计划类型
    async findnewPlanTypeList(){
      const res = await findnewPlanTypeList({customerCode: this.conditions.customer})
      this.planTypeList = res.data || []
    },
    // 历史数据
    async findSaleplanHistory(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        planType: this.conditions.plan_type,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 0
      }
      // const params = {
      //   brand: '0122',
      //   customerCode: '0050000215',
      //   planType: this.conditions.plan_type,
      //   saleCenter: this.conditions.sal_center,
      //   year: this.conditions.gjahr - 0
      // }
      const res = await findSaleplanHistory(params)
      this.gridOptionsPlanDetail.data = res.data
      this.conditions.pre_aloc_plan_qty = res.data[0]?.signedQty || ''
      this.conditions.viola_qty = res.data[0]?.breakRuleQty || ''
      this.conditions.legacy_deduction = res.data[0]?.omitQty || ''
    },
    // 销售区域
    async findContractArea(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 1,
        newPlanType: this.conditions.plan_type,
      }
      const res = await findContractArea(params)
      this.gridOptionArea.data = res.data
    },
    // 销售渠道
    async findContractChannel(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 1,
        newPlanType: this.conditions.plan_type,
      }
      const res = await findContractChannel(params)
      this.channelList = res.data || []
    },

    // 生成OA文件附件并上传服务器
    async getSendOAFiles(){
      this.errorList = []
      this.$refs.oaForm.validate(async(val, err) => {
        if (val){
          const params = [{
            ...this.conditions,
            ...this.gridOptionsPlanDetail.data[0],
          }]
          const res = await getSendOAFiles(params)
          if(res.data.status === '0'){
            return Message.warning('提交失败')
          }
          this.saveData('SUBMIT_OA', res.data?.fileList)
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    async saveData(mode, data = []){

      this.errorList = []
      this.$refs.form.validate(async(val, err) => {
        if (val) {
          if(mode !== 'CANCEL' && mode !== 'SUBMIT_OA' && this.isApprove){
            // const planQty23 = this.gridOptionsPlanDetail.data[0].planQty23 - 0
            const trimOptions = this.gridOptions.data[this.gridOptions.data.length - 1]
            if(trimOptions.total - 0 !== trimOptions.aloc_total_qty - 0){
              this.errorList.push('计划量调整明细的申请计划量不等于月度计划量合计')
              return
            }
            // if(( trimOptions.total-0 > planQty23 * 1.1 || trimOptions.total-0 < planQty23 * 0.9) && !this.conditions.spct_note && !this.isChangeList){
            //   this.errorList.push('请填写特殊说明')
            //   return
            // }
            // let monthNum1 = trimOptions.plan_qty_12 - 0 + trimOptions.plan_qty_1 - 0 + trimOptions.plan_qty_2 - 0
            // let monthNum2 = trimOptions.plan_qty_3 - 0 + trimOptions.plan_qty_4 - 0 + trimOptions.plan_qty_5 - 0
            // let monthNum3 = trimOptions.plan_qty_6 - 0 + trimOptions.plan_qty_7 - 0 + trimOptions.plan_qty_8 - 0
            // let monthNum4 = trimOptions.plan_qty_9 - 0 + trimOptions.plan_qty_10 - 0 + trimOptions.plan_qty_11 - 0
            // if(monthNum1 - 0 < planQty23 * 0.1 || monthNum2 - 0 < planQty23 * 0.1 || monthNum3 - 0 < planQty23 * 0.1 || monthNum4 - 0 < planQty23 * 0.1){
            //   this.errorList.push('每个季度不能低于总量10%')
            //   return
            // }
          }
          let es_submit = []
          if(mode === 'SUBMIT_OA'){
            es_submit = [{
              sal_center: this.conditions.sal_center,
              plan_type: this.conditions.plan_type,
              approval_no: this.conditions.approval_no,
              ...this.dialogForm,
              file_name: data[0].fileName,
              file_addr: data[0].fileUrl,
            }]
          }
          // 选择渠道
          const qudao = []
          this.channelList.length > 0 && this.channelList.forEach((item) => {
            qudao.push({
              ...item,
              chl_name: item.chlName
            })
          });
          // 区域
          const area = []
          this.gridOptionArea.data.forEach(ele => {
            area.push({
              ...ele,
              city_name: ele.city_name,
              regn_name: ele.regn_name,
              street_name: ele.street_name,
            })

          });
          if(this.conditions.status === 'E004'){
            if(this.conditions.zassign){
              if(this.conditions.assign.length === 0){
                this.errorList.push('请选择大区副总')
                return
              }
            }else{
              this.conditions.assign = []
              this.assignLists = []
            }
          }
          let lssl = []
          this.gridOptionsPlanDetail.data.length > 0 && this.gridOptionsPlanDetail.data.forEach(ele => {
            lssl.push({
              plan_cntr_no: this.conditions.plan_cntr_no,
              plan_qty_21:ele.planQty21 ,
              plan_qty_22:ele.planQty22 ,
              plan_qty_23:ele.planQty23 ,
              bill_qty_21:ele.billQty21 ,
              bill_qty_22:ele.billQty22 ,
              bill_qty_23:ele.billQty23 ,
              deliver_qty_21:ele.deliverQty21 ,
              deliver_qty_22:ele.deliverQty22 ,
              deliver_qty_23:ele.deliverQty23 ,
              // left_qty_21:ele. ,
              // left_qty_22:ele. ,
              // left_qty_23:ele. ,
              selled_stock:ele.selledStock ,
              selled_qty_21:ele.selledQty21 ,
              selled_qty_22:ele.selledQty22 ,
              selled_qty_23:ele.selledQty23 ,
            })
          });
          const params = {
            mode,
            user_bp: this.role.USER_BP,
            head: this.conditions,
            qudao,
            attachment: this.gridOptionsFile.data,
            area,
            bgjhl: this.bgjhl,
            item: [this.gridOptions.data[this.gridOptions.data.length - 1]],
            ext_sys: '',
            lssl,
            es_submit,
            audit_comment: this.conditions.audit_comment,
            dept_code: this.role.deptCode,
            assign: this.checkAssign
          }
          const api = this.isChangeList ? spctChgOrder : spctNewOrder
          const res = await api(params)
          this.errorList = []
          if(res.msgtype === 'S'){
            const {plan_cntr_no} = this.$route.query
            if(plan_cntr_no){
              this.getSpctById(plan_cntr_no)
            }
            this.gridOptions.columns.forEach((ele,index) => {
              if(ele.field === 'qty_type_text' || ele.field === 'total'){
                this.gridOptions.columns.splice(index,1)
              }
            });
            this.showOaDialog = false
            this.isEdit = true
          }else{
            if(mode === 'SUBMIT_OA'){
              return Message.warning(res.message)
            }
            this.errorList.push(res.message)
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 渠道类型
    // async getContractQd() {
    //   const { DATA } = await apiGetContractQd()
    //   this.$set(this.selectDataOptions, 'contractQd', DATA)
    // },
    async uploadFile(file) {
      // console.log(file);
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        const dateTime = new Date().getTime()

        const fileData = {
          filename: file.name,
          mimetype: file.raw.type,
          doc_type: file.raw.type,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.role.USER_BP,
          uname_text: _this.role.login_user,
          created_date: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          created_time: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
    },
     // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    // 控件回车
    async handleEnter(e, type, data) {
      console.log('handleEnter', type, data)
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.customer = data.customerCode
          this.conditions.cust_name = data.customerName
          this.conditions.customer_type = data.customerType
          this.saleCenterLists = data.orgList
          this.conditions.sal_center = data.orgList[0].zzfld00001h
          this.conditions.saleCenterTextView = data.orgList[0].mc_short
          this.findnewPlanTypeList()
          this.findchflList()
          break
      }
    },
    openDialog(e){
      e.target.blur()
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.conditions.customer = data.customerCode
        this.conditions.cust_name = data.customerName
        this.conditions.customer_type = data.customerType
        this.saleCenterLists = data.orgList
        this.conditions.sal_center = data.orgList[0].zzfld00001h
        this.conditions.saleCenterTextView = data.orgList[0].mc_short
      }
      this.showDialog = false
    },
    saleCenterChange(e){
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD000001Name = checkedData.mc_short
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
    },
    zassignChange(e){
      e && this.getCenterFz(this.conditions, 'YES')
      this.conditions.assign = []
      this.assignLists = []
    },
    assignBpChange(list){
      this.checkAssign = []
      this.conditions.assign = []
      list.forEach(ele => {
        this.deputyLists.forEach(item => {
          if(ele === item.partner){
            this.conditions.assign.push(item)
            this.checkAssign.push(item)
          }
        });
      });

    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
  /deep/ .el-textarea{
    .el-textarea__inner{
      color: #333;
    }
  }
  .lg-label{
    /deep/ .el-form-item__label{
      width: 194px !important;
    }
    /deep/ .el-form-item__content{
      width: calc(100% - 204px) !important;
    }
  }
  // /deep/ .el-form-item__content{
  //   width: calc(100% - 100px) !important;
  // }
  .mark{
    font-weight: normal;
    font-size: 12px;
    padding-right: 18px;
    line-height: 24px;
    color: #333;
    /deep/ .el-form-item__label{
      width: 290px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/qy-manage/salePlanEdit.vue